import { useEffect, useState } from 'react';

/**
 * Observa si el body tiene la clase "hidden" (controlada por theme-main.js
 * al abrir/cerrar el menú hamburguesa) y devuelve un boolean reactivo.
 * No modifica el DOM.
 */
export function useMenuOpen() {
  const [isMenuOpen, setIsMenuOpen] = useState(
    () => document.body.classList.contains('hidden')
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsMenuOpen(document.body.classList.contains('hidden'));
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  return isMenuOpen;
}